export function featureEnabled(feature: any): boolean {
    return ['1', 'true', 1, true].includes(feature)
}
